import { catalog } from "../i18n.js";

/** The pane beside the chat (components/Details.tsx): its overview and the titles of its parts. */
export const DETAILS = catalog(
  {
    titleDetails: "Details",
    titleSettings: "Settings",
    titleRoutines: "Routines",
    titleSkills: "Skills",
    titleMemory: "Memory",
    titleConversation: "Full conversation",
    titleWhatsApp: "WhatsApp",
    titleContacts: "WhatsApp conversations",

    back: "Back",
    backToDetails: "Back to details",
    settingsTitle: "Settings: name, label, description, avatar, notifications",
    hideDetails: "Hide details",
    hidePane: "Hide this pane",

    loading: "Loading…",
    createRoutineLabel: "Create a routine",
    manageRoutines: "Manage routines",
    routinesAbout: (group: boolean) => `Routines are recurring tasks this ${group ? "group" : "bot"} runs on a schedule.`,
    createRoutine: "Create routine",
    openRoutine: (name: string) => `Edit ${name}`,
    nextRun: (when: string) => `next ${when}`,
    paused: "paused",

    tasks: "Tasks",
    openTasks: (count: number) => `${count} open`,

    browse: "Browse",
    open: "Open",
    memoryAbout: "What the bot has kept from your conversations.",
    memoryEmpty: "Nothing kept yet. Facts worth keeping are noted after each conversation.",
    memoryCounts: (own: number, shared: number) => `${own} fact${own === 1 ? "" : "s"} of its own${shared > 0 ? `, ${shared} shared about you` : ""}.`,

    manage: "Manage",
    writeSkill: "Write a skill",
    skillsAbout: "Skills are written procedures the bot follows when a task matches one.",

    members: "Members",
    remove: "Remove",
    removeFromGroup: (name: string) => `Remove ${name} from the group`,
    noMembers: "Nobody is in this group yet.",
    everyBotIn: "Every bot is already in this group.",
    groupFull: (max: number) => `A group holds ${max} at most`,
    addBotToGroup: "Add a bot to this group",
    addMember: "Add member",

    noDescription: "No description yet. Add one in Settings.",
    openLarge: "Open large.",
    screenOf: (name: string) => `${name}’s screen`,
    inUse: ", in use",
    show: "Show",
    conversationAbout: "Everything the bot did between its messages: private notes, reasoning, tool calls and helpers.",
  },
  {
    titleDetails: "Detail",
    titleSettings: "Pengaturan",
    titleRoutines: "Rutinitas",
    titleSkills: "Keahlian",
    titleMemory: "Memori",
    titleConversation: "Percakapan lengkap",
    titleWhatsApp: "WhatsApp",
    titleContacts: "Percakapan WhatsApp",

    back: "Kembali",
    backToDetails: "Kembali ke detail",
    settingsTitle: "Pengaturan: nama, label, deskripsi, avatar, notifikasi",
    hideDetails: "Sembunyikan detail",
    hidePane: "Sembunyikan panel ini",

    loading: "Memuat…",
    createRoutineLabel: "Buat rutinitas",
    manageRoutines: "Kelola rutinitas",
    routinesAbout: (group: boolean) => `Rutinitas adalah tugas berulang yang dijalankan ${group ? "grup" : "bot"} ini sesuai jadwal.`,
    createRoutine: "Buat rutinitas",
    openRoutine: (name: string) => `Ubah ${name}`,
    nextRun: (when: string) => `berikutnya ${when}`,
    paused: "dijeda",

    tasks: "Tugas",
    openTasks: (count: number) => `${count} belum selesai`,

    browse: "Lihat",
    open: "Buka",
    memoryAbout: "Hal-hal yang disimpan bot dari percakapan kamu.",
    memoryEmpty: "Belum ada yang disimpan. Fakta yang penting dicatat setelah setiap percakapan.",
    memoryCounts: (own: number, shared: number) => `${own} fakta miliknya sendiri${shared > 0 ? `, ${shared} tentang kamu yang dibagikan` : ""}.`,

    manage: "Kelola",
    writeSkill: "Tulis keahlian",
    skillsAbout: "Keahlian adalah prosedur tertulis yang diikuti bot saat ada tugas yang cocok.",

    members: "Anggota",
    remove: "Hapus",
    removeFromGroup: (name: string) => `Hapus ${name} dari grup`,
    noMembers: "Belum ada anggota di grup ini.",
    everyBotIn: "Semua bot sudah ada di grup ini.",
    groupFull: (max: number) => `Satu grup maksimal berisi ${max}`,
    addBotToGroup: "Tambahkan bot ke grup ini",
    addMember: "Tambah anggota",

    noDescription: "Belum ada deskripsi. Tambahkan di Pengaturan.",
    openLarge: "Sedang dibuka besar.",
    screenOf: (name: string) => `Layar ${name}`,
    inUse: ", sedang dipakai",
    show: "Tampilkan",
    conversationAbout: "Semua yang dikerjakan bot di antara pesan-pesannya: catatan pribadi, penalaran, pemanggilan tool, dan helper.",
  },
);
